import { useFormContext } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { GraphQL } from '@guestgoodie/graphql'
import { Trans } from '@lingui/react/macro'

import { localesLabels } from '@/features/translations'

export function Error({ name }: { name: string }) {
  const {
    formState: { errors }
  } = useFormContext()

  return (
    <ErrorMessage
      name={name}
      errors={errors}
      render={({ message }) => {
        return (
          <span className="pl-2 text-regular text-red-500" role="alert">
            {message}
          </span>
        )
      }}
    />
  )
}

export function TranslationError({
  name,
  locale
}: {
  name: string
  locale: GraphQL.AppLocale
}) {
  const {
    formState: { errors }
  } = useFormContext()

  if (
    !locale ||
    !('translations' in errors) ||
    !errors.translations ||
    typeof errors.translations !== 'object'
  ) {
    return null
  }

  const erroredLocales = Object.entries(errors.translations)
    .map(function ([loc, value]) {
      const fields = Object.keys(value)

      if (fields.includes(name)) return loc as GraphQL.AppLocale
      return null
    })
    .filter(item => item != null)

  if (erroredLocales.length < 1) return null
  if (erroredLocales.includes(locale)) return null

  const locales = localesLabels(erroredLocales).join(',')

  return (
    <span className="pl-2 text-regular text-red-500" role="alert">
      <Trans>Errors in {locales}</Trans>
    </span>
  )
}
